<div class="modal">
  <div class="modal-overlay" (click)="cancel($event)"></div>
  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h4 class="modal-title">{{ modalTitle }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel($event)"></button>
      </div>
      <div class="modal-body">
        <fieldset class="form-group">
          @for (addressItem of addressList; track addressItem; let i = $index) {
            <div class="form-check d-flex my-3">
              <input class="form-check-input align-self-center" type="radio" name="address_ptions_radio" [id]="i" [checked]="selectedAddress == addressItem" (click)="select(i, addressItem)" />
              <app-address-detail
                class="w-100 ms-2"
                [address]="addressItem"
                [showDeleteButton]="true"
                [addressUsageType]="knownAddressUsageTypeEnum"
                (click)="select(i, addressItem)"
                (deleteAddressEvent)="adressDeleteItem($event)"
              ></app-address-detail>
            </div>
          }
        </fieldset>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" i18n="@@DialogAddressSelectYesButton" [class.disabled]="!isAddressSelected" (click)="submit($event)">Select</button>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" i18n="@@DialogAddressSelectNoButton" (click)="cancel($event)">Back</button>
      </div>
    </div>
  </div>
</div>
